(function (d) {
  let verify = d.querySelector('.verify')

  let cbox = d.getElementById('vdc')
  cbox.setAttribute('aria-checked', false);

  let butt = d.getElementById('vdcb')
  let url = butt.href

  if (!localStorage.getItem('isacdedc')) {
    hideButton()
    determineDC()
  } else {
    showButton()
    verify.hidden = true
    cbox.checked = true;
    cbox.setAttribute('aria-checked', true);
  }

  function determineDC () {
    let checked;
    cbox.addEventListener('click', () => {
      checked = cbox.getAttribute('aria-checked') === 'true';
      if (checked) {
        cbox.setAttribute('aria-checked', false);
        hideButton()
      } else {
        cbox.setAttribute('aria-checked', true);
        showButton()
      }
    });
  }

  function showButton () {
    butt.classList.remove('disabled')
    butt.href = url
    butt.setAttribute('target', '_blank')
    butt.setAttribute('rel', 'noopener noreferrer')
  }

  function hideButton () {
    butt.classList.add('disabled')
    butt.href = ''
    butt.removeAttribute('target')
    butt.removeAttribute('rel')
  }

  function populate() {
    localStorage.setItem('isacdedc', 1)
  }

  butt.addEventListener('click', (el) => {
    if (butt.classList.contains('disabled') === true) {
      el.preventDefault()
    } else {
      populate()
    }
  });

}(document));
